// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2ZWvf","modal":"Modal_modal__3BwOn","paragraph":"Modal_paragraph__iU2IE","button":"Modal_button__3BVej"};